import { useContext } from 'react';
import AppContext from 'app/AppContext';
import { usePortfolioReturnsConfigSlice } from 'widgets/portfolioReturns/store/configuration/configSlice';
import { usePortfolioReturnsComponentSlice } from 'widgets/portfolioReturns/store/component/componentSlice';

export type PriceMovementVersusType = 'specificDate' | 'prevClose' | 'avgExec';

export function usePortfolioReturnsPriceMovementVersus() {
    const { timeFormat } = useContext(AppContext);

    const { component } = usePortfolioReturnsComponentSlice();

    const { config } = usePortfolioReturnsConfigSlice();

    const { basisDay, basisTime } = component;
    const { useAvgExecPrice } = config;

    const value: PriceMovementVersusType =
        basisDay || basisTime
            ? 'specificDate'
            : useAvgExecPrice
            ? 'avgExec'
            : 'prevClose';

    const description = basisTime
        ? `${timeFormat.toDate(basisDay!.getTime())} ${basisTime.hours}:${
              basisTime.mins
          }`
        : basisDay
        ? timeFormat.toDate(basisDay.getTime())
        : useAvgExecPrice
        ? 'Average Execution Price'
        : 'Previous Close (as of end date)';

    return {
        priceMovementVersus: value,
        priceMovementVersusDescription: description,
    };
}
